module.exports = __webpack_public_path__ + "assets/img/fire-hit.ca3de3a8.png";